var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 10"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M1.197 10C.673 10 .31 9.753.108 9.26c-.202-.493-.121-.917.242-1.272L8.153.355C8.395.118 8.677 0 9 0c.323 0 .605.118.847.355l7.803 7.633c.363.355.444.78.242 1.272-.202.493-.565.74-1.089.74H1.197z"}})])};var toString = function () {return "/app/static/svg/tc_share_open.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./static/svg/tc_share_open.svg
// module id = 1001
// module chunks = 39 100 112